import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ModuleHeader from "./ModuleHeader";
import ReactEcharts from "echarts-for-react";
import { REM_CONFIG } from "@/utils/fontSize";
const defaultData = [
    { month: "1月", budget: 65, execution: 55 },
    { month: "2月", budget: 78, execution: 30 },
    { month: "3月", budget: 52, execution: 68 },
    { month: "4月", budget: 60, execution: 55 },
    { month: "5月", budget: 55, execution: 50 },
    { month: "6月", budget: 75, execution: 82 },
    { month: "7月", budget: 90, execution: 30 },
    { month: "8月", budget: 40, execution: 60 },
    { month: "9月", budget: 68, execution: 48 },
    // { month: "10月", budget: 30, execution: 70 },
    // { month: "11月", budget: 45, execution: 60 },
    // { month: "12月", budget: 95, execution: 90 },
];
const BudgetExecution = ({ className = "", data = defaultData, }) => {
    const months = data.map((item) => item.month);
    const budgetData = data.map((item) => item.budget);
    const executionData = data.map((item) => item.execution);
    const getEchartsOption = () => ({
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" },
            backgroundColor: "rgba(0, 20, 50, 0.8)",
            borderColor: "rgba(68, 240, 255, 0.3)",
            textStyle: { color: "#fff" },
        },
        legend: {
            show: true,
            data: ["预算", "执行"],
            textStyle: { color: "#ffffff", fontSize: REM_CONFIG.fontSize.small },
            top: 8,
            right: "center",
            itemWidth: 12,
            itemHeight: 12,
        },
        xAxis: {
            type: "category",
            data: months,
            boundaryGap: false,
            axisLabel: {
                color: "#fff",
                fontSize: REM_CONFIG.fontSize.small, // 微调字号（避免14px在12个标签时拥挤）
                interval: 0, // 强制显示所有标签（核心配置，0=不跳过任何标签）
            },
            axisLine: {
                show: true,
                lineStyle: { color: "#446b9f", width: 1 },
            },
            axisTick: { show: false },
            splitLine: { show: false },
        },
        grid: {
            left: 50,
            right: "6%",
            bottom: 24, // 底部空间从10%增至18%（给12个标签足够垂直空间）
            top: 60,
            // containLabel: true, // 强制grid包含标签（避免标签超出容器）
        },
        yAxis: [
            {
                type: "value",
                name: "金额（万元）",
                nameTextStyle: {
                    color: "#ffffff",
                    fontSize: REM_CONFIG.fontSize.small,
                },
                axisLabel: {
                    color: "#fff",
                    fontSize: REM_CONFIG.fontSize.small,
                    formatter: "{value}",
                },
                splitLine: {
                    lineStyle: { color: "rgba(255,255,255,0.1)", type: "dashed" },
                },
                axisLine: { show: false },
                axisTick: { show: false },
            },
        ],
        series: [
            {
                name: "预算",
                type: "line",
                data: budgetData,
                itemStyle: { color: "#F89842" },
                lineStyle: { color: "#F89842", width: 2 },
                symbol: "circle",
                symbolSize: 6,
                showSymbol: true,
                emphasis: {
                    itemStyle: { color: "#F89842", borderColor: "#fff", borderWidth: 2 },
                },
            },
            {
                name: "执行",
                type: "line",
                data: executionData,
                itemStyle: { color: "#44F0FF" },
                lineStyle: { color: "#44F0FF", width: 2 },
                areaStyle: {
                    color: {
                        type: "linear",
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                            { offset: 0, color: "rgba(68, 240, 255, 0.3)" },
                            { offset: 0.5, color: "rgba(68, 240, 255, 0.1)" },
                            { offset: 1, color: "rgba(68, 240, 255, 0)" },
                        ],
                    },
                },
                symbol: "circle",
                symbolSize: 6,
                showSymbol: true,
                emphasis: {
                    itemStyle: { color: "#44F0FF", borderColor: "#fff", borderWidth: 2 },
                },
            },
        ],
    });
    return (_jsxs("div", { className: `
        relative 
        bg-gradient-to-t 
        from-[rgba(7,31,75,0.5)] 
        to-[rgba(6,32,66,0.2)] 
       
        flex flex-col 
        min-h-0
        ${className}
      `, children: [_jsx(ModuleHeader, { title: "\u9884\u7B97\u6267\u884C" }), _jsx("div", { className: "flex-1 min-h-0", children: _jsx(ReactEcharts, { option: getEchartsOption(), style: { width: "100%", height: "100%" } }) })] }));
};
export default BudgetExecution;
